import { useAuthStore } from '@/store/auth-store'

export function useAuth() {
  const { user, isAuthenticated } = useAuthStore()

  return {
    user,
    isAuthenticated,
    can: (permission: string) => user?.permissions.includes(permission) ?? false,
  }
}
